import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { INgxManageLayoutActionButton, INgxManageLayoutConfirmation } from '../../models/ngx-manage-layout.model';
import { NgxValidationService } from '../../../services/ngx-validation.service';
import { ConfirmationService } from 'primeng/api';
import { NgxUtility } from '../../../core/_utility/utility';

@Component({
  selector: 'ngx-manage-action-layout',
  templateUrl: './ngx-manage-action-layout.component.html',
  styleUrls: ['./ngx-manage-action-layout.component.scss']
})
export class NgxManageActionLayoutComponent implements OnInit {

  // action items
  @Input() actions: INgxManageLayoutActionButton[] = [];
  // confirmations
  @Input() confirmations: INgxManageLayoutConfirmation[] = [];
  // form group
  @Input() form: FormGroup;
  // on submit
  @Output() onAction = new EventEmitter<INgxManageLayoutActionButton>();
  // dialog key
  dialogKey: string;

  constructor(private validationService: NgxValidationService,
    private confirmDialog: ConfirmationService) { }

  ngOnInit(): void {
    // init dialog key
    this.dialogKey = `action_layout_cd_${NgxUtility.getUniqueString()}`;
    // check there is no actions
    if (this.actions.length == 0) {
      this.actions.push({ key: 'submit', name: 'Submit', styleClass: 'p-button-sm p-button-outlined mr-2', validate: true });
      this.actions.push({ key: 'cancel', name: 'Cancel', styleClass: 'p-button-sm p-button-outlined p-button-danger', validate: false });
    }
  }

  handleAction(item: INgxManageLayoutActionButton) {
    if (item.validate) {
      if (this.form.valid) {
        // check confirm action
        this.checkConfirmation(item, () => {
          this.onAction.emit(item);
        });
      }
      else {
        this.validationService.fireFormGroupValidation(this.form);
      }
    }
    else {
      // check confirm action
      this.checkConfirmation(item, () => {
        this.onAction.emit(item);
      });
    }
  }

  private checkConfirmation(action: INgxManageLayoutActionButton, callback: () => void) {
    if (this.confirmations && this.confirmations.length > 0) {
      // get the confirm info
      const confirmInfo = this.confirmations.find(m => m.key == action.key);
      if (confirmInfo) {
        this.confirmDialog.confirm({
          header: confirmInfo.heading ? confirmInfo.heading : 'Confirmation',
          message: confirmInfo.message,
          key: this.dialogKey,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            callback();
          }
        })
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

}
